import { Component, OnInit } from '@angular/core';
import { PaymentService, ProductDisplay, Subscription } from '../payment.service';

@Component({
    selector: 'cart-view',
    templateUrl: './cart-view.component.html',
    styleUrls: ['./cart-view.component.css'],
    standalone: false
})
export class CartViewComponent implements OnInit{
  subs: Subscription[];
  selectedSub: Subscription;
  products: ProductDisplay[];
  selectedProduct: ProductDisplay;

  constructor(private paymentService: PaymentService){

  }

  async goToCheckout(){
    const session = await this.paymentService.getCheckoutSession(this.selectedProduct);
    if(session){
      const { error } = await this.paymentService.checkout(session.id);
    }
  }

  selectProduct(product: ProductDisplay){
    this.selectedProduct = product;
  }

  async ngOnInit(): Promise<void> {
    this.subs = [];
    this.products = [];
    this.selectedSub = this.subs[0];
    this.products = await this.paymentService.getProducts();
    this.selectedProduct = this.products[0];
  }

}
